export const SUBMIT = 'WITHDRAWAL/SUBMIT'
export const SUBMIT_SUCCESS = 'WITHDRAWAL/SUBMIT_SUCCESS'
export const SUBMIT_ERROR = 'WITHDRAWAL/SUBMIT_ERROR'
export const RESET = 'WITHDRAWAL/RESET'
